module.exports = __webpack_public_path__ + "img/zone100250.2278a0ea.png";